if (!window.Maximize.loadedScript.includes("recently-viewed.js")) {
  window.Maximize.loadedScript.push("recently-viewed.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store("xProductRecently", {
        show: false,
        loading: true,
        productsToShow: 0,
        productsToShowMax: 10,
        listRecentlyProducts: [],
        currentProductId: "",
        requestVersion: 0,
        normalizeIds(values) {
          if (!Array.isArray(values)) return [];
          return [...new Set(values.map((value) => {
            if (typeof value === "number" && !Number.isSafeInteger(value)) return "";
            return typeof value === "string" || typeof value === "number" ? String(value).trim() : "";
          }).filter((value) => /^[1-9]\d*$/.test(value)))].slice(0, this.productsToShowMax);
        },
        readSectionSettings() {
          const section = document.getElementById("RecentlyViewedSection");
          if (section) {
            this.productsToShow = Math.min(this.productsToShowMax, Math.max(2, Number(section.dataset.productsToShow) || 4));
            this.currentProductId = this.normalizeIds([section.dataset.currentProductId])[0] || "";
          }
          return section;
        },
        init() {
          try {
            this.listRecentlyProducts = this.normalizeIds(JSON.parse(localStorage.getItem("recently-viewed") || "[]"));
          } catch (_) {
            this.listRecentlyProducts = [];
          }
          this.readSectionSettings();
        },
        showProductRecently() {
          this.readSectionSettings();
          this.show = this.listRecentlyProducts.some((id) => id !== this.currentProductId);
        },
        setProduct(productViewed) {
          const productId = this.normalizeIds([productViewed])[0];
          if (!productId) return;
          this.currentProductId = productId;
          this.listRecentlyProducts = this.normalizeIds([productId, ...this.listRecentlyProducts]);
          this.show = this.listRecentlyProducts.some((id) => id !== productId);
          try {
            localStorage.setItem("recently-viewed", JSON.stringify(this.listRecentlyProducts));
          } catch (_) {}
        },
        async getProductRecently(sectionId, productId) {
          const version = ++this.requestVersion;
          const section = this.readSectionSettings();
          const el = section && section.querySelector(".recently-viewed__content");
          const currentId = this.normalizeIds([productId])[0] || this.currentProductId;
          const products = this.normalizeIds(this.listRecentlyProducts).filter((id) => id !== currentId).slice(0, this.productsToShow);
          if (!el || !products.length) {
            this.show = false;
            this.loading = false;
            return;
          }
          this.show = true;
          this.loading = true;
          const query = products.map((id) => "id:" + id).join(" OR ");
          const searchUrl = `${Shopify.routes.root}search?section_id=${encodeURIComponent(sectionId)}&type=product&q=${encodeURIComponent(query)}`;
          try {
            const response = await fetch(searchUrl);
            if (!response.ok) throw new Error("Recently viewed section unavailable");
            const text = await response.text();
            if (version !== this.requestVersion) return;
            const results = new DOMParser().parseFromString(text, "text/html").querySelector("#RecentlyViewedSection .recently-viewed__content");
            const container = results && results.querySelector(".slider-container");
            if (!container) throw new Error("Recently viewed section missing");
            const cards = new Map();
            container.querySelectorAll("[data-recently-viewed-product-id]").forEach((card) => {
              const id = card.dataset.recentlyViewedProductId;
              if (products.includes(id) && !cards.has(id)) cards.set(id, card);
              else card.remove();
            });
            if (!cards.size) {
              this.show = false;
              return;
            }
            // Search relevance is not browsing history: restore the saved most-recent-first order.
            products.forEach((id) => {
              if (cards.has(id)) container.appendChild(cards.get(id));
            });
            el.innerHTML = results.innerHTML;
            this.show = true;
            document.dispatchEvent(new CustomEvent(`${ANIMATION_EVENT.revealItem}`));
          } catch (_) {
            if (version === this.requestVersion) this.show = false;
          } finally {
            if (version === this.requestVersion) this.loading = false;
          }
        },
        clearHistory() {
          let result = confirm("Are you sure you want to clear your recently viewed products?");
          if (result === true) {
            ++this.requestVersion;
            this.listRecentlyProducts = [];
            try {
              localStorage.removeItem("recently-viewed");
            } catch (_) {}
            this.show = false;
            this.loading = false;
          }
        },
      });
    });
  });
}
